import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  deviceId:null
};

const deviceSlice = createSlice({
  name: 'deviceIdValues',
  initialState,
  reducers: {
    send(state,action) {
        state.deviceId = action.payload.deviceId;
    },
  },
});

export const { send } = deviceSlice.actions;
export default deviceSlice.reducer;